import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { BrandingService } from './branding.service';

@Injectable()
export class BrandingTitleStrategy extends TitleStrategy {
  constructor(
    private readonly title: Title,
    private readonly branding: BrandingService
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot): void {
    const built = this.buildTitle(routerState);
    const companyName = this.branding.brand.companyName;
    if (built) {
      this.title.setTitle(built.replace(/^Alphastar/, companyName));
      return;
    }
    this.title.setTitle(companyName);
  }
}
